import React, { useContext, useState, useEffect } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import "./style.css";
import { FileSearch, CirclePlus } from "lucide-react";
import axios from "axios";
import { base_url } from "../../config";

function SearchPapers({ registrationComplete = false }) {
  const { setPaperOpen, setPaperSelected } = useContext(RegistrationContext);
  const [filteredPapers, setFilteredPapers] = useState([]);
  const [papers, setPapers] = useState([]);

  useEffect(() => {
    axios.get(`${base_url}/api/papers`).then((response) => {
      setPapers(response.data);
      setFilteredPapers(response.data);
    });
  }, []);
  const paperClicked = (paperId) => {
    setPaperOpen(false);
    setPaperSelected(paperId);
  };

  // function to filter papers based on search input
  const filterPapers = (event) => {
    const searchInput = event.target.value;
    const mfilteredPapers = papers.filter((paper) => {
      return (
        paper.title.toLowerCase().includes(searchInput.toLowerCase()) ||
        paper.id.toString().includes(searchInput.toLowerCase())
      );
    });
    setFilteredPapers([...mfilteredPapers]);
  };

  return (
    <div className="search-papers-form paper-input-container flex flex-col justify-center px-6 py-8 mx-auto h-full lg:py-0 text-left">
      <div className="flex text-white gap-4">
        <div>
          <FileSearch size={30} />
        </div>
        <div
          className="sectionTitle"
          style={{ color: "white", marginBottom: "50px" }}
        >
          Add a Paper to Your Registration
        </div>
      </div>
      <p className="text-white text-sm" style={{ marginTop: "-2rem", marginBottom: "1rem" }}>
        If you cannot find your paper, it may not yet be available in the system.{!registrationComplete && " You can complete your registration now and add your paper later once it becomes available."}
      </p>
      <div className="my-8">
        <form className="mx-auto">
          <label
            htmlFor="default-search"
            className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
          >
            Search
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                aria-hidden="true"
                className="w-4 h-4 text-gray-500 dark:text-gray-400"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 19l-4-4m0-7A7 7 0 111 8a7 7 0 0114 0z"
                ></path>
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Type your paper Title or ID"
              onChange={(event) => filterPapers(event)}
              required
            />
          </div>
        </form>
      </div>
      <div className="w-full h-full bg-white rounded-lg shadow md:mt-0 xl:p-0 overflow-y-auto ">
        <div className="w-full p-6 space-y-4 md:space-y-6 sm:p-8 text-xs">
          {filteredPapers.map((paper, index) => {
            return (
              <div key={index} className="flex items-start gap-3 py-1 border-b border-gray-100 last:border-0">
                <div className="flex-grow min-w-0">
                  <div className="text-[#002E78] font-medium mb-0.5">{paper.type}</div>
                  <div className="flex items-baseline gap-2">
                    <span className="bg-ecmlBrown text-white px-1.5 py-0.5 rounded text-[10px] shrink-0">#{paper.id}</span>
                    <span className="text-black leading-snug">{paper.title}</span>
                  </div>
                </div>
                <CirclePlus
                  size="16"
                  className="shrink-0 mt-0.5 cursor-pointer text-[#002E78] hover:text-ecmlBrown"
                  onClick={() => paperClicked(`${paper.type}-${paper.id}`)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
export default SearchPapers;
